import { io, type Socket } from 'socket.io-client';
import { API_ORIGIN } from '../api/client';

let playerRealtimeSocket: Socket | null = null;

export const getPlayerRealtimeSocket = (): Socket => {
  if (!playerRealtimeSocket) {
    playerRealtimeSocket = io(API_ORIGIN, {
      autoConnect: false,
      withCredentials: true,
      transports: ['websocket'],
    });
  }

  return playerRealtimeSocket;
};
